import { render, staticRenderFns } from "./skdform.vue?vue&type=template&id=85dcc09e&scoped=true&"
import script from "./skdform.vue?vue&type=script&lang=js&"
export * from "./skdform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85dcc09e",
  null
  
)

export default component.exports